/* shop.debands.xyz — theme toggle and reveal on scroll.
   Ported from debands_landing_page/assets/js/site.js (without the scroll
   rail), plus re-running the reveal when the theme editor re-renders a
   section. */
(function () {
  var root = document.documentElement;

  /* Theme. Same storage key as app.debands.xyz and debands.xyz. */
  var toggle = document.getElementById('theme-toggle');
  var themeMeta = document.getElementById('theme-color-meta');
  function applyThemeMeta() {
    if (themeMeta) themeMeta.setAttribute('content', root.classList.contains('dark') ? '#050506' : '#f4f4f5');
  }
  if (toggle) {
    toggle.addEventListener('click', function () {
      var isDark = root.classList.toggle('dark');
      try { localStorage.setItem('debands_landing_theme', isDark ? 'dark' : 'light'); } catch (e) {}
      applyThemeMeta();
    });
  }

  /* Reveal on scroll. Without IntersectionObserver, show everything. */
  var observer = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' })
    : null;

  function reveal(scope) {
    scope.querySelectorAll('.fade-up:not(.visible)').forEach(function (el) {
      if (observer) observer.observe(el);
      else el.classList.add('visible');
    });
  }
  reveal(document);

  /* Theme editor: a section added or edited arrives as fresh markup. */
  document.addEventListener('shopify:section:load', function (e) {
    reveal(e.target);
  });
})();
